import React from 'react';
import {FaCheck, FaExclamationTriangle, FaTimes} from "react-icons/fa";

const StatusCellRenderer = ({value}) => {
    switch (value) {
        case "ERROR":
            return <FaTimes className="text-red-800"/>
        case "WARNING":
            return <FaExclamationTriangle className="text-yellow-500"/>
        case "ACTIVE":
            return <FaCheck className="text-green-700"/>
        default: return <FaTimes className="text-red-800"/>
    }
};

export default StatusCellRenderer;